// extracted by mini-css-extract-plugin
export default {"background":"style_background__dI1ML","container":"style_container__N25-0","animationWrapper":"style_animationWrapper__ArpEO"};